// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Lieferant } from "../../api";
import { useGetLieferant as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useLieferant(
  id: string,
  options: Omit<
    UseQueryOptions<Lieferant, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): Lieferant {
  const getter = useGetter();
  return useQuery(["lieferanten", id], () => getter(id), options).data!;
}
